<template>
  <div class="card-wrap">
    <div class="conversation-wrap">
      <div :class="['container2', { collapsed: !showAsideMenu }]">
        <!-- logo -->
        <div
          class="logo"
          v-if="showAsideMenu"
          @click="goToWeb('https://www.gpowersoft.com/')"
        >
          <div class="img">
            <div class="gp-img-repostive">
              <img src="@/assets/logo.png" alt="" />
            </div>
          </div>
        </div>
        <!-- 关闭按钮 -->
        <div class="close" v-if="showAsideMenu" @click="targetAsideMenu">
          <img src="@/assets/images/top_close_icon.png" alt="" />
        </div>
        <!-- 热点答疑 -->
        <div class="hot-topic" v-if="showAsideMenu">
          <div class="title">
            <span>热点答疑</span>
            <img src="@/assets/images/rank_bg.png" alt="" />
          </div>
          <div class="bottom-list">
            <div
              class="list-item"
              v-for="(item, index) in hotQuestion.slice(
                (page - 1) * 6,
                hotQuestion.length > page * 6 ? page * 6 : hotQuestion.length,
              )"
              :key="(page - 1) * 6 + index + 1"
            >
              <div
                class="content"
                :title="item.content"
                @click="send(item.content)"
              >
                {{ item.content }}
              </div>
              <!-- <div @click="send(item.content)">
                <img src="../../../assets/images/send.png" height="20">
            </div> -->
            </div>
          </div>
          <div
            class="refresh"
            @click="
              () => page++ === Math.ceil(hotQuestion.length / 6) && (page = 1)
            "
          >
            换一批
            <g-icon type="icon-shuaxin" style="font-size: 16px" />
          </div>
        </div>
        <div class="target-icon" @click="targetAsideMenu">
          <img
            v-if="!showAsideMenu"
            src="@/assets/images/open_icon.png"
            alt=""
          />
          <img
            v-if="showAsideMenu"
            src="@/assets/images/close_icon.png"
            alt=""
          />
        </div>
        <!-- 最近问答 -->
        <!-- <div class="Recent">3</div> -->
      </div>
      <!-- 对话框 -->
      <div
        class="container1"
        :style="{
          marginLeft: showAsideMenu ? '5%' : '0px',
          maxWidth: showAsideMenu ? 'calc(100% - 43%)' : 'calc(100% - 23%)',
        }"
      >
        <!-- 置顶信息 -->
        <div class="top-information" v-if="topInformation">
          <span>{{ topInformation }}</span>
        </div>
        <div class="chat-history">
          <div class="main" ref="Conversation">
            <div
              :class="['section', item.form, item.activate && 'activate']"
              v-for="(item, index) in history"
              :key="index"
              @mouseenter="item.activate = true"
              @mouseleave="item.activate = false"
            >
              <img
                class="avatar"
                v-if="item.form === 'left' && ktrw == 'isKtrw'"
                src="@/assets/images/switch_but1.png"
                alt=""
              />
              <img
                class="avatar"
                v-if="item.form === 'left' && ktrw == 'noKtrw'"
                src="@/assets/images/switch_but2.png"
                alt=""
              />
              <div class="wrap">
                <span class="text">
                  <vue-markdown toc v-if="item.form === 'left'">
                    {{ item.content }}
                  </vue-markdown>
                  <span v-else>
                    {{ item.content }}
                  </span>
                </span>
                <div class="tool">
                  <a-icon
                    :style="{ color: '#fff' }"
                    type="copy"
                    color="#fff"
                    title="复制"
                    @click="$copy(item.content)"
                  />
                </div>
              </div>
              <img
                class="avatar"
                v-if="item.form === 'right'"
                src="@/assets/images/avatar_icon.png"
                alt=""
              />
            </div>
            <div v-if="messages.length" class="section left">
              <div class="wrap">
                <span class="text">
                  <typewriter-text
                    :text="messages.join('')"
                    :typing-speed="typingSpeed"
                    @typing-completed="handleTypingCompleted"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="chat-input">
          <div class="main">
            <div class="top-box">
              <a-textarea
                v-model="question"
                placeholder="输入内容开始聊天（Shift+Enter换行）..."
                :rows="1"
                class="gp-input"
                @keydown="handleKeydown"
              />
              <!-- <div class="length">{{ question.length }}/100</div> -->
              <div class="send">
                <a-button
                  v-if="!loading"
                  type="primary"
                  shape="round"
                  class="send-button"
                  @click="send()"
                >
                  发送
                  <i class="send-icon"></i>
                </a-button>
                <a-button
                  v-else
                  type="danger"
                  shape="round"
                  class="stop-button"
                  @click="stopChat"
                >
                  <a-icon
                    type="pause-circle"
                    style="font-size: 16px; margin-right: 4px"
                  />
                  停止生成
                </a-button>
              </div>
            </div>
            <div class="topis">内容由AI生成，请仔细甄别</div>
          </div>
        </div>
      </div>
      <!-- 人物 -->
      <div :class="ktrw == 'isKtrw' ? 'ktrw robot' : 'robot'">
        <div class="img-pos">
          <img
            v-if="ktrw == 'isKtrw'"
            src="@/assets/video/ktrw.gif"
            height="443"
          />
          <img v-else src="@/assets/video/rw.gif" height="543" />
          <!-- <video
            :key="ktrw ? 'ktrw-video' : 'rw-video'"
            autoplay
            muted
            loop
            class="video-dom"
          >
            <source
              :src="
                ktrw
                  ? require('@/assets/video/ktrw.mp4')
                  : require('@/assets/video/rw.mp4')
              "
              type="video/mp4"
            />
          </video> -->
        </div>
      </div>
      <!-- 切换人物 -->
      <div class="switch-button">
        <div
          class="but but1"
          :class="{ active: ktrw == 'isKtrw' }"
          @click="switchPerson('noKtrw')"
        ></div>
        <div
          class="but but2"
          :class="{ active: ktrw == 'noKtrw' }"
          @click="switchPerson('isKtrw')"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  chatMessage,
  getMessages,
  stopTask,
  getSuggestedQuestions,
  storeQA,
  getCommonQuestions,
} from "@/apis/dify";
import VueMarkdown from "vue-markdown";
import TypewriterText from "@/components/TypewriterText.vue";
import hotServer from "@/DataSet/hotServer.json";

export default {
  components: {
    VueMarkdown,
    TypewriterText,
  },
  data() {
    return {
      question: "",
      page: 1,
      messages: [],
      hotServer,
      hotQuestion: [],
      currentUser: "gpower",
      loading: false,
      topInformation: "", //置顶信息
      showAsideMenu: true, //侧边栏显示
      ktrw: "isKtrw", //显示卡通人物
      conversation_id: "", // 对话ID
      task_id: "", // 当前回复任务id
      message_id: "", // 当前消息ID
      typingSpeed: 30, // 打字机效果速度（毫秒/字符）
      isWaitingForCompletion: false, // 是否等待打字机效果完成
      currentAbortController: null, // 存储当前请求的中断控制器
      history: [
        {
          form: "left",
          content: "你好，关于通元软件的问题，向我提问吧。",
          activate: false,
        },
      ],
    };
  },
  mounted() {
    // 使用事件委托处理动态渲染的图片点击事件
    this.$refs.Conversation.addEventListener("click", (event) => {
      if (event.target.tagName === "IMG") {
        // 检查图片是否在消息内容区域
        const textElement = event.target.closest(".text");

        // 只有在 .text 区域内的图片才触发预览（这确保了是聊天内容中的图片）
        if (textElement) {
          // 阻止默认行为（如链接跳转等）
          event.preventDefault();
          // 调用预览函数
          this.previewImageFromElement(event);
        }
      }
    });
  },
  created() {
    this.getData();
    // 从本地存储中恢复打字速度设置
    const savedSpeed = localStorage.getItem(
      `${process.env.VUE_APP_NAME}:typing_speed`,
    );
    if (savedSpeed) {
      this.typingSpeed = parseInt(savedSpeed);
    }
  },
  watch: {
    // message_id(newV) {
    //   newV && this.getSuggestList()
    // }
  },
  methods: {
    // 关闭/打开侧边栏
    targetAsideMenu() {
      this.showAsideMenu = !this.showAsideMenu;
    },
    switchPerson(type) {
      this.ktrw = type;
    },
    goToWeb(url) {
      window.open(url);
    },
    scroll() {
      const target = this.$refs.Conversation;
      // 滚动到底部
      this.$nextTick(() => {
        target.scrollTop = target?.scrollHeight;
      });
    },
    handleTypingCompleted(text) {
      if (this.isWaitingForCompletion) {
        this.history.push({
          form: "left",
          content: text,
          activate: false,
        });
        this.messages = [];
        this.scroll();
        this.loading = false;
        this.isWaitingForCompletion = false;
        this.currentAbortController = null;
        this.storeData();
      }
    },
    handleKeydown(e) {
      const event = e;
      const shortCutKeys = ["metaKey", "altKey", "ctrlKey", "shiftKey"];
      const isEnterKey = event.key === "Enter";
      const isShortcutKeys = shortCutKeys.some((item) => event[item]);
      if (isEnterKey && isShortcutKeys) {
        console.log(isShortcutKeys);
      } else if (event.key === "Enter") {
        event.preventDefault();
        this.send(); // 发送问题
      }
    },
    getSuggestList() {
      // 需要dify开启建议功能
      getSuggestedQuestions(this.message_id, { user: this.currentUser }).then(
        (res) => {
          console.log(
            "⏰ ~ file: main.vue:171 ~ getSuggestedQuestions ~ res:",
            res,
          );
        },
      );
    },
    storeData() {
      sessionStorage.setItem(
        `${process.env.VUE_APP_NAME}:conversation_id`,
        this.conversation_id,
      );
    },
    storeQuestionAndAnswer(q, a) {
      storeQA({ session_id: this.conversation_id, q, a });
    },
    getData() {
      const conversation_id = sessionStorage.getItem(
        `${process.env.VUE_APP_NAME}:conversation_id`,
      );
      if (conversation_id) {
        this.conversation_id = conversation_id;
        getMessages({ conversation_id, user: this.currentUser, limit: 100 })
          .then((res) => {
            res.data.map((v) => {
              this.history.push({
                form: "right",
                content: v.query,
                activate: false,
              });
              this.history.push({
                form: "left",
                content: v.answer,
                activate: false,
              });
            });
          })
          .finally(() => {
            this.scroll();
          });
      }
      getCommonQuestions().then((res) => {
        if (res.data?.length) {
          this.hotQuestion = res.data.map((item) => ({
            content: item.content,
          }));
        }
      });
    },
    stopChat() {
      if (this.currentAbortController) {
        this.currentAbortController.abort();
        this.currentAbortController = null;
      }
      if (this.task_id) {
        stopTask(this.task_id, { user: this.currentUser }).catch(() => {});
      }
      if (this.messages.length > 0) {
        const finalContent = this.messages.join("");
        if (finalContent.trim()) {
          this.history.push({
            form: "left",
            content: finalContent,
            activate: false,
          });
        }
        this.messages = []; // 清空数组，TypewriterText 组件会销毁或停止
      }
      this.loading = false;
      this.isWaitingForCompletion = false;
      this.scroll();
      this.storeData();
    },
    send(q) {
      // 防止重复发起对话请求
      if (this.loading) return;
      if (!q && !this.question) return;
      if (this.currentAbortController) {
        this.currentAbortController.abort();
      }
      const controller = new AbortController();
      this.currentAbortController = controller;
      this.loading = true;
      const question = q || this.question;
      this.history.push({ form: "right", content: question, activate: false });
      // 重置消息，确保打字机效果正确开始
      this.messages = [];
      this.isWaitingForCompletion = false; // 重置等待完成标志
      this.scroll();
      this.topInformation = question;
      this.question = "";
      chatMessage(
        {
          query: question,
          user: this.currentUser,
          inputs: {},
          conversation_id: this.conversation_id || "",
          response_mode: "streaming",
        },
        {
          signal: controller.signal,
          onmessage: (stream) => {
            if (stream.event == "workflow_started") {
              this.conversation_id = stream.conversation_id;
              this.task_id = stream.task_id;
              this.message_id = stream.message_id;
            }
            if (stream.event === "message") {
              this.messages.push(stream.answer);
              this.scroll();
            }
            if (stream.event === "message_end") {
              this.isWaitingForCompletion = true;
            }
          },
          onerror: (err) => {
            if (controller.signal.aborted) {
              console.log("Chat stopped by user");
              return;
            }
            this.loading = false;
            this.currentAbortController = null;
            this.$message.error(err || "网络错误");
          },
        },
      );
      this.question = "";
    },
    // 调整打字机速度的方法
    setTypingSpeed(speed) {
      this.typingSpeed = speed;
      // 保存打字速度到本地存储，下次使用时恢复
      localStorage.setItem(`${process.env.VUE_APP_NAME}:typing_speed`, speed);
    },
    // 图片预览方法
    // 通过事件对象获取图片源并预览
    previewImageFromElement(event) {
      const imgElement = event.target;
      if (imgElement && imgElement.src) {
        this.$previewImage(imgElement.src);
      }
    },
  },
};
</script>

<style lang="less" scoped>
p {
  margin-bottom: 0;
}
.card-wrap {
  position: relative;
  height: 100vh;
  overflow-y: auto;
  // align-items: center;
  .conversation-wrap {
    display: flex;
    height: 100%;
    justify-content: space-between;
  }
  .robot {
    position: relative;
    text-align: center;
    width: 18%;
    .img-pos {
      position: relative;
      bottom: -20%;
      height: 0;
      padding-bottom: 136%;
      /* 设置容器背景为透明或与页面背景一致 */
      background: transparent;
    }
    // &.ktrw {
    //   width: 18%;
    //   .img-pos {
    //     padding-bottom: 136%;
    //   }
    // }
    .video-dom {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      /* 添加混合模式实现透明效果 */
      mix-blend-mode: multiply;

      /* 可选：添加过渡效果 */
      transition: mix-blend-mode 0.3s ease;
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain; /* 保持图片比例 */
    }
  }
  .container1 {
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-end;
    .top-information {
      padding: 5px 40px 5px 12px;
      background-color: #17405f;
      color: #8cffeb;
      font-size: 16px;
      width: max-content;
      border-radius: 10px;
      margin-top: 60px;
    }
    .chat-history {
      display: flex;
      justify-content: center;
      width: 100%;
      height: calc(100% - 340px);
      border: 1px solid rgba(51, 51, 51, 0.1);
      border-top: none;
      border-left: none;
      margin-bottom: 20px;
      margin-top: 60px;
      .main {
        scroll-behavior: smooth;
        overflow: auto;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding-block: 40px;
        /* 隐藏滚动条但保留滚动功能 */
        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }

        -ms-overflow-style: none; /* IE 10+ */
        scrollbar-width: none; /* Firefox */
        .section {
          width: 100%;
          box-sizing: border-box;
          margin: 10px 0;
          display: flex;
          flex-wrap: wrap;
          align-content: center;
          color: rgba(51, 51, 51, 1);
          &.left {
            .wrap {
              border-radius: 20px;
              background: rgba(12, 38, 83, 0.8);
              position: relative;
              margin-left: 10px;
              .tool {
                display: none;
                position: absolute;
                right: 5px;
                bottom: 5px;
              }
            }
            &.activate {
              .tool {
                display: block;
                cursor: pointer;
                transition: all 0.3s;
                &:hover {
                  color: #1890ff;
                }
              }
            }
          }
          &.right {
            color: white;
            justify-content: flex-end;
            .wrap {
              border-radius: 20px;
              background: rgba(198, 0, 11, 0.6);
              position: relative;
              margin-right: 10px;
              .tool {
                display: none;
                position: absolute;
                right: 15px;
                color: #333333;
                bottom: 0;
              }
            }
            &.activate {
              .tool {
                display: block;
                cursor: pointer;
                transition: all 0.3s;
                &:hover {
                  color: #1890ff;
                }
              }
            }
          }
          .avatar {
            width: 50px;
            height: 50px;
          }
          .wrap {
            max-width: 90%;
            width: fit-content;
            display: flex;
            padding: 5px 25px;
            flex-direction: row;
            flex-wrap: nowrap;
            border-radius: 15px;
            justify-content: center;
            align-items: center;
            .text {
              font-family: "PingFang SC Microsoft YaHei";
              font-size: 16px;
              overflow-x: hidden;
              line-height: 1.7;
              color: #fff;
              width: 100% !important;
              word-wrap: break-word;
            }
          }
        }
      }
    }
    .chat-input {
      width: 85%;
      margin: 0 auto;
      margin-bottom: 20px;
      .main {
        .top-box {
          display: flex;
          position: relative;
          border-radius: 20px;
          background-color: #fff;
        }
        .gp-input {
          height: 125px;
          border: none;
          border-radius: 20px;
          resize: none;
          font-size: 16px;
          overflow: auto;
          padding: 10px;
          /* 隐藏滚动条但保持滚动功能 */
          &::-webkit-scrollbar {
            display: none; /* 针对WebKit浏览器（Chrome, Safari等） */
          }

          -ms-overflow-style: none; /* 针对IE和Edge */
          scrollbar-width: none; /* 针对Firefox */

          &:focus {
            box-shadow: unset;
          }
        }
        .send {
          display: flex;
          align-items: flex-end;
          padding-right: 10px;
          padding-bottom: 5px;

          .send-button,
          .stop-button {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            height: 36px;
            min-width: 96px;
            padding: 0 20px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            transition: all 0.3s ease;
            letter-spacing: 1px;
            font-size: 18px;
            color: #bebece;
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
            position: relative;
            overflow: hidden;

            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            }

            &:active {
              transform: translateY(1px);
              box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

              &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 5px;
                height: 5px;
                background: rgba(255, 255, 255, 0.5);
                opacity: 0;
                border-radius: 100%;
                transform: scale(1);
                animation: ripple 0.6s ease-out;
              }
            }
          }

          .send-button {
            background-color: transparent;
            border: none;
            position: relative;
            overflow: hidden;
            font-weight: normal;
            font-size: 18px;
            box-shadow: none;
            .send-icon {
              display: inline-block;
              width: 18px;
              height: 17px;
              margin-left: 12px;
              background: url("@/assets/images/send_icon.png") no-repeat center
                center;
              background-size: contain;
            }
            &:hover {
              color: #fff;
              background-color: #325fff;
              .send-icon {
                background: url("@/assets/images/send_icon_hover.png") no-repeat
                  center center;
              }
            }
          }

          .stop-button {
            background: linear-gradient(135deg, #ff7170 0%, #e84141 100%);
            border: none;
            position: relative;
            overflow: hidden;
            color: #fff;
          }
        }
        .topis {
          margin-top: 10px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.4);
        }
      }
    }
  }
  .container2 {
    width: 18%;
    flex-shrink: 0;
    padding: 46px 20px;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    background-color: rgba(12, 38, 83, 0.5);
    border-right: 1px solid #446a84;
    transition: all 0.3s ease-in-out;
    .logo {
      cursor: pointer;
      padding-bottom: 30px;
      border-bottom: 1px solid #446a84;
      .img {
        width: 68%;
        margin: 0 auto;
        .gp-img-repostive {
          padding-bottom: 22.41%;
          width: 100%;
          height: 0;
          overflow: hidden;
          display: block;
          img {
            width: 100%;
            transition: all 0.5s ease-in-out;
            max-width: none;
          }
        }
      }
    }
    .close {
      width: 15px;
      height: 13px;
      margin: 20px 0;
      margin-left: auto;
    }
    .hot-topic {
      padding-left: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #446a84;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px 10px;
        color: #8cffeb;
        font-size: 16px;
        background-color: #17405f;
        border-radius: 10px;
        margin-bottom: 20px;
      }
      .bottom-list {
        color: #739bb3;
        font-size: 15px;
        .list-item {
          cursor: pointer;
          width: 100%;
          // 添加以下样式实现单行省略号显示
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 25px;
        }
      }
      .refresh {
        text-align: center;
        cursor: pointer;
        color: #8cffeb;
      }
    }
    .target-icon {
      cursor: pointer;
      position: absolute;
      right: -18px;
      top: 50%;
    }
    &.collapsed {
      width: 0px;
      padding: 0;
    }
  }
  .switch-button {
    position: absolute;
    top: 45px;
    right: 40px;
    .but {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      cursor: pointer;
    }
    .active {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 0%;
        left: 0%;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 50%;
      }
    }
    .but1 {
      margin-bottom: 25px;
      background: url("@/assets/images/switch_but2.png") no-repeat center / 100%
        100%;
    }
    .but2 {
      background: url("@/assets/images/switch_but1.png") no-repeat center / 100%
        100%;
    }
  }
  .header {
    width: 100%;
    cursor: pointer;
  }
}
// @media screen and (max-width: 1400px) {
//   .card-wrap .robot {
//     width: 22%;
//     margin-right: 105px;
//   }
// }
// @media screen and (max-width: 1320px) {
//   .card-wrap .robot {
//     width: 20%;
//     margin-right: 60px;
//   }
// }
@media screen and (max-width: 996px) {
  .card-wrap .robot {
    display: none;
  }
  .card-wrap .container1 {
    width: 70%;
  }
  .card-wrap .container2 {
    width: 25%;
  }
}
@media screen and (max-width: 768px) {
  .card-wrap {
    width: 560px;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) rotate(30deg);
  }
  100% {
    transform: translateX(100%) rotate(30deg);
  }
}

@keyframes ripple {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(40);
    opacity: 0;
  }
}
</style>
